import { render } from "./SaleReport.vue?vue&type=template&id=66608c7d&scoped=true"
import script from "./SaleReport.vue?vue&type=script&lang=js"
export * from "./SaleReport.vue?vue&type=script&lang=js"

import "./SaleReport.vue?vue&type=style&index=0&id=66608c7d&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66608c7d"]])

export default __exports__